import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './UpdateSuccessModal.css';

var UpdateSuccessModal = function (props) {
  var isOpen = props.isOpen !== undefined ? props.isOpen : true;
  var message = props.message || 'Updated successfully!';
  var subtitle = props.subtitle || 'Your changes have been saved.';
  var onClose = props.onClose;

  useEffect(function () {
    if (!isOpen) return;
    var handleKeyDown = function (e) {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  var modalContent = React.createElement('div', {
    className: 'update-success-overlay',
    onClick: function (e) {
      if (e.target === e.currentTarget && onClose) {
        onClose();
      }
    }
  },
    React.createElement('div', {
      className: 'update-success-card',
      role: 'dialog',
      'aria-modal': 'true'
    },
      // X Close button
      React.createElement('button', {
        type: 'button',
        className: 'update-success-close-btn',
        onClick: onClose,
        'aria-label': 'Close'
      },
        React.createElement('svg', {
          width: 16,
          height: 16,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        },
          React.createElement('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
          React.createElement('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
        )
      ),

      // Green Checkmark icon
      React.createElement('div', { className: 'update-success-icon-wrap' },
        React.createElement('svg', {
          width: 34,
          height: 34,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: '#10b981',
          strokeWidth: 2.8,
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        },
          React.createElement('polyline', { points: '20 6 9 17 4 12' })
        )
      ),

      // Title Message
      React.createElement('h2', { className: 'update-success-title' }, message),

      // Subtitle
      subtitle && React.createElement('p', { className: 'update-success-subtitle' }, subtitle),

      // Action buttons
      React.createElement('div', { className: 'update-success-actions' },
        React.createElement('button', {
          type: 'button',
          className: 'update-success-ok-btn',
          onClick: onClose
        }, 'OK')
      )
    )
  );

  if (typeof document !== 'undefined' && document.body && ReactDOM.createPortal) {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
};

export default UpdateSuccessModal;
